import { createSelector } from 'reselect';

import { StateSchema } from 'app/providers/StoreProvider';
import { isEmpty } from 'shared/lib/lodash/lodash';

const selectNewAddedItems = (state: StateSchema) =>
    state.catalogItem?.newAddedItems;

export const getCatalogItems = (state: StateSchema) =>
    state.catalogItem?.dataList;

export const getCatalogItemsTotalCount = (state: StateSchema) =>
    state.catalogItem?.dataList?.length || 0;

export const getSelectedCatalogItems = (state: StateSchema) =>
    state.catalogItem.selectedItems;

export const getSelectedCatalogItem = (state: StateSchema) =>
    state.catalogItem.selectedItem;

export const getCatalogItemsSelectedIsEmpty = (state: StateSchema) =>
    isEmpty(state.catalogItem?.selectedItems);

export const getSelectedCatalogItemsTotal = (state: StateSchema) =>
    Object.values(state.catalogItem?.selectedItems || {}).length;

export const getNewAddedItemsTotal = (state: StateSchema) =>
    Object.keys(state.catalogItem?.newAddedItems || {}).length;

export const getNewCatalogItemsTotal = (state: StateSchema) =>
    Object.values(state.catalogItem?.newAddedItems || {}).filter(
        (item) => item.source === 'catalog',
    ).length;

export const getNewInventoryItemsTotal = (state: StateSchema) =>
    Object.values(state.catalogItem?.newAddedItems || {}).filter(
        (item) => item.source === 'inventory',
    ).length;

export const getSelectedMarketplaceItemsTotal = (state: StateSchema) =>
    Object.values(state.catalogItem?.newAddedItems || {}).filter(
        (item) => item.source === 'marketplace',
    ).length;

export const getNewPropertyCatalogItemsTotal = (state: StateSchema) =>
    Object.values(state.catalogItem?.newAddedItems || {}).filter(
        (item) => item.source === 'catalog' || item.source === 'inventory',
    ).length;

export const getNewPropertyCatalogItemsTotalByCategoryMap = createSelector(
    [selectNewAddedItems],
    (newAddedItems) =>
        Object.values(newAddedItems || {}).reduce<Record<string, number>>(
            (acc, item) => {
                if (item.source === 'catalog' && item.categoryId) {
                    acc[item.categoryId] = (acc[item.categoryId] || 0) + 1;
                }
                return acc;
            },
            {},
        ),
);

export const getSelectedMarketplaceItemsTotalByCategoryMap = createSelector(
    [selectNewAddedItems],
    (newAddedItems) =>
        Object.values(newAddedItems || {}).reduce<Record<string, number>>(
            (acc, item) => {
                if (item.source === 'marketplace' && item.categoryId) {
                    acc[item.categoryId] = (acc[item.categoryId] || 0) + 1;
                }
                return acc;
            },
            {},
        ),
);

export const getSelectedMarketplaceItemsTotalBySubCategoryMap = createSelector(
    [selectNewAddedItems],
    (newAddedItems) =>
        Object.values(newAddedItems || {}).reduce<Record<string, number>>(
            (acc, item) => {
                if (item.source === 'marketplace' && item.subCategoryId) {
                    acc[item.subCategoryId] =
                        (acc[item.subCategoryId] || 0) + 1;
                }
                return acc;
            },
            {},
        ),
);

export const getCatalogItemsAreLoading = (state: StateSchema) =>
    state.catalogItem.listIsLoading;

export const getCatalogItemsShowDetailedView = (state: StateSchema) =>
    state.catalogItem.showDetailedView;

export const getProposalsLoading = (state: StateSchema) =>
    state.catalogItem.proposalsLoading;
